import type { TrendDelta } from '@dashboard/types/analytics.types'
import cn from '@integrations/classnames'
import styles from './TrendPill.module.scss'

interface Props {
  delta: TrendDelta
}

/** Period-over-period delta badge, shared by the KPI strip and the balance chart headline. */
function TrendPill({ delta }: Props) {
  return (
    <span
      className={cn(
        styles['trend-pill'],
        'trend-pill',
        styles[`trend-pill--${delta.direction}`],
        `trend-pill--${delta.direction}`
      )}
    >
      {delta.value}
    </span>
  )
}

export default TrendPill
